const PHASES = ["Breathe in", "Hold", "Breathe out", "Hold"];
const SIDE = 4000;

// Animated square: a dot travels one side every 4 seconds while the square gently grows and shrinks
export const BoxBreath = ({ elapsed, still }) => {
  const phase = Math.floor(elapsed / SIDE) % 4, p = (elapsed % SIDE) / SIDE;
  const scale = phase === 0 ? 0.82 + 0.18 * p : phase === 1 ? 1 : phase === 2 ? 1 - 0.18 * p : 0.82;
  const pts = [[0, 100], [0, 0], [100, 0], [100, 100]];
  const [x0, y0] = pts[phase], [x1, y1] = pts[(phase + 1) % 4];
  const count = 4 - Math.floor(p * 4);
  return (
    <div className="flex flex-col items-center" data-testid="calm-box">
      <div className="relative w-48 h-48 sm:w-56 sm:h-56">
        <div className="absolute inset-0" style={{ transform: `scale(${still ? 1 : scale})`, transition: still ? "none" : "transform 120ms linear" }}>
          <div className="absolute inset-0 rounded-[28px] bg-gradient-to-br from-[#C9B8F0] to-[#A8D8EA] shadow-lg" />
          {!still && <span className="absolute w-5 h-5 -ml-2.5 -mt-2.5 rounded-full bg-white shadow ring-4 ring-white/40" style={{ left: `${x0 + (x1 - x0) * p}%`, top: `${y0 + (y1 - y0) * p}%` }} aria-hidden />}
        </div>
        <div className="absolute inset-0 flex flex-col items-center justify-center text-[#2E2546]">
          <div className="text-2xl font-bold" aria-live="polite" data-testid="calm-box-cue">{PHASES[phase]}</div>
          <div className="text-4xl font-extrabold mt-1 tabular-nums" aria-hidden>{count}</div>
        </div>
      </div>
    </div>
  );
};

export const boxPhase = (elapsed) => Math.floor(elapsed / SIDE);
